module.exports = __webpack_public_path__ + "static/img/gwzaapp.56297bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download/gwzaapp.png
// module id = HxCr
// module chunks = 0